import RiFileCopyLine from '@ben/icons/file-copy-line';
import { ActionIcon, CopyButton } from '@mantine/core';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import MantineTooltip from '../mantine-tooltip';
import RIcon from '../remix-icon';

export interface CopyIconProps {
  value?: string;
}

const CopyIcon = ({ value }: CopyIconProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  if (!value) {
    return;
  }

  return (
    <CopyButton value={value} timeout={2000}>
      {({ copy, copied }) => (
        <MantineTooltip
          label={
            copied
              ? t('phrases.copiedToClipboard', {
                  defaultValue: 'Copied to clipboard',
                })
              : t('words.copy', { defaultValue: 'Copy' })
          }
          withArrow
          position="right"
        >
          <ActionIcon
            aria-label={`${t('words.copy', { defaultValue: 'Copy' })} ${value}`}
            onClick={copy}
            variant="transparent"
          >
            <RIcon icon={RiFileCopyLine} color={theme.palette.neutral[90]} />
          </ActionIcon>
        </MantineTooltip>
      )}
    </CopyButton>
  );
};

export default memo(CopyIcon);
